import { AdPodFilter, AdPodUpdate, ListResult, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

import { AdPod, AdPodInit } from 'common/api/v1/types'
import { AdPodsRequestParams, PaginatedRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export interface IAdPodsApi {
  listAdPods(params?: PaginatedRequestParams): Promise<ListResult<AdPod>>
  getAdPod(id: AdPod['id']): Promise<AdPod>
  createAdPod(adPod: AdPodInit): Promise<AdPod>
  updateAdPod(id: AdPod['id'], adPod: AdPod): Promise<AdPod>
  deleteAdPod(id: AdPod['id']): Promise<AdPod>
}

export class AdPodsApi implements IAdPodsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdPods(params: AdPodsRequestParams): Promise<ListResult<AdPod>> {
    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      adCreativeId: params.adCreativeId,
      status: params.status,
    } as AdPodFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    return this.edgeClient.listAdPods(query)
  }

  getAdPod(id: string): Promise<AdPod> {
    return this.edgeClient.getAdPod(id)
  }

  createAdPod(adPod: AdPodInit): Promise<AdPod> {
    return this.edgeClient.createAdPod(adPod)
  }

  updateAdPod(id: string, adPod: AdPodUpdate): Promise<AdPod> {
    return this.edgeClient.updateAdPod(id, adPod)
  }

  deleteAdPod(id: string): Promise<AdPod> {
    return this.edgeClient.deleteAdPod(id)
  }
}
